import {
  STOCK_PHOTO_RATIO,
  stockPhotoSrc,
  stockPhotos,
  type StockPhotoId,
} from "@/data/stockPhotos";
import { cn } from "@/lib/utils";

export interface PhotoProps {
  id: StockPhotoId;
  /** Classes do `<img>`; por padrão preenche o pai (`h-full w-full object-cover`). */
  className?: string;
  /** `sizes` do srcset; o padrão cobre coluna de até ~600px no desktop. */
  sizes?: string;
  /** Fundo/ilustração ao lado de texto que já diz tudo → `alt=""`. */
  decorative?: boolean;
}

/**
 * Foto de banco livre servida de `public/images/stock/` (ver
 * `src/data/stockPhotos.ts`). Sempre `lazy` — foto não entra acima da dobra
 * nem vira LCP. O pai define proporção e raio (`aspect-*`, `overflow-hidden`,
 * `rounded-*`); no escuro a foto escurece um pouco para não estourar.
 */
export function Photo({
  id,
  className,
  sizes = "(max-width: 900px) 100vw, 600px",
  decorative = false,
}: PhotoProps) {
  const photo = stockPhotos[id];
  return (
    <img
      src={stockPhotoSrc(id, 1600)}
      srcSet={`${stockPhotoSrc(id, 800)} 800w, ${stockPhotoSrc(id, 1600)} 1600w`}
      sizes={sizes}
      width={1600}
      height={Math.round(1600 * STOCK_PHOTO_RATIO)}
      alt={decorative ? "" : photo.alt}
      loading="lazy"
      decoding="async"
      style={"position" in photo ? { objectPosition: photo.position } : undefined}
      className={cn("h-full w-full object-cover dark:brightness-[.85]", className)}
    />
  );
}
